<template>
  <div>
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="topTitle"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
      staticMode="true"
    ></TopAppBar>
    <div class="d-flex h-full flex-column ">
    <TopAppBarDrawer></TopAppBarDrawer>
    <main class="main-wrapper flex-grow-1 ">
        <div class="d-flex align-items-center bg-white">
            <div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
               {{$t('1956')}}
            </div>
        </div>
        <div class="divider"></div>
        <!-- subtabs -->
        <div class="container container--narrow pdb-50">
      <div class="d-flex flex-column mgt-30 mgb-8">
          <div class="t-body3 t-color-signBlue font-r mgb-8" v-if="listData && listData.response===true">{{$t('1959')}}</div>
          <div class="t-body3 t-color-red font-r mgb-8" v-if="listData && listData.response===false">{{$t('1957')}}</div>
          <div class="t-body3 t-color-bodyGrayA font-rn" v-if="listData">{{$moment(listData.requestDate).format('L')}}</div>
          <div class="t-subtitle6 font-r l-line-h-24 l-spacing6 mgt-8">
              {{listData ? listData.contents:''}}
          </div>
      </div>
      <div class="mgt-24 ans-details-correct pdl-16 position-relative" v-if="listData && listData.responseDate">
          <div class="t-body3 t-color-bodyGrayA font-r mgb-4">{{$moment(listData.responseDate).format('L')}}</div>
          <div class="t-body6 font-r l-spacing45 t-line-h-24">
              {{listData?listData.responseContents:''}}
          </div>
      </div>

        <!-- <div class="divider"></div> -->
        <!-- <div class="t-helper l-spacing39 t-color-bodyGrayA font-13 font-r pdl-16 pdt-16 pdb-8">{{ $t('1958')}}</div> -->

        <choice-single-report v-if="listData && singleChoice" :listData="listData" :singleChoice="singleChoice">
        </choice-single-report>

        <choice-multiple-report v-if="listData && multipleChoice" :listData="listData" :multipleChoice="multipleChoice">
        </choice-multiple-report>

        <short-answer-report  v-if="listData && shortAnswer" :listData="listData" :shortAnswer="shortAnswer">
        </short-answer-report>

        <true-false  v-if="listData && trueFalse" :listData="listData" :trueFalse="trueFalse">
        </true-false>

        <fill-in-the-blank  v-if="listData && fillInTheBlank" :listData="listData" :fillInTheBlank="fillInTheBlank">
        </fill-in-the-blank>
        <!-- {{listData}}
        {{FillInTheRanges}} -->
        <fill-in-the-range  v-if="listData && fillInTheRange" :listData="listData" :fillInTheRange="fillInTheRange">
        </fill-in-the-range>
        <essay-report  v-if="listData && essay" :listData="listData" :essay="essay">
        </essay-report>
    </div>
        </main>
  </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import examApi from "@/api/examApi.js";
import memberApi from "@/api/memberApi.js";
import ChoiceSingleReport from './ChoiceSingleReport.vue';
import ChoiceMultipleReport from './ChoiceMultipleReport.vue';
import ShortAnswerReport from './ShortAnswerReport.vue';
import TrueFalseReport from './TrueFalseReport.vue';
import FillInTheBlankReport from './FillInTheBlankReport.vue';
import FillInTheRangeReport from './FillInTheRangeReport.vue';
import EssayReport from './EssayReport.vue';
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

export default {
  components: {
   TopAppBar,
   'choice-single-report': ChoiceSingleReport,
   'choice-multiple-report': ChoiceMultipleReport,
   'short-answer-report': ShortAnswerReport,
   'true-false': TrueFalseReport,
   'fill-in-the-blank': FillInTheBlankReport,
   'fill-in-the-range': FillInTheRangeReport,
   'essay-report':EssayReport,
   TopAppBarDrawer
  },

  data() {
    return {
      listData:  null,
      singleChoice: null,
      multipleChoice: null,
      shortAnswer: null,
      trueFalse: null,
      fillInTheBlank: null,
      fillInTheRange: null,
      essay: null,
      topTitle: localStorage.getItem('brandName')
    };
  },

  mixins: [topAppBarMixin],

  mounted() {
      this.setTopAppBarBackPreviousPage(this.$t('1956'))
      let param = this.$route.params;
      this.fetchData(param)
  },


  methods: {
    fetchData(param) {
      let memberTotalPoint = null
        memberApi
          .memberPoint()
          .then((response) => {
            this.memberTotalPoint = response.data.data;
        }).catch((err) => {});

      let params = param;
      examApi.eaxmIssueDetail(params)
          .then((response) => {
            this.listData = response.data.data;
            //console.log('report detail this.listData',this.listData)

            if(this.listData && this.listData.question && this.listData.question.singleChoice.choiceList && this.listData.question.singleChoice.choiceList[0].contents) {
              this.singleChoice = this.listData.question ? this.listData.question.singleChoice.choiceList: null;
            }
            if(this.listData && this.listData.question && this.listData.question.multipleChoice.choiceList && this.listData.question.multipleChoice.choiceList[0].contents) {
              this.multipleChoice = this.listData.question ? this.listData.question.multipleChoice.choiceList: null;
            }

            if(this.listData && this.listData.question && this.listData.question.shortAnswer && this.listData.question.shortAnswer.textAnswer) {
              this.shortAnswer = this.listData.question ? this.listData.question.shortAnswer: null;
            }

            if(this.listData && this.listData.question && this.listData.question.trueFalse && this.listData.question.trueFalse.answerFalse && this.listData.question.trueFalse.answerFalse.contents) {
              this.trueFalse = this.listData.question ? this.listData.question.trueFalse: null;
            }

            if(this.listData && this.listData.question && this.listData.question.fillInTheBlank && this.listData.question.fillInTheBlank.contents) {
              this.fillInTheBlank = this.listData.question ? this.listData.question.fillInTheBlank: null;
            }

            if(this.listData && this.listData.question && this.listData.question.fillInTheRange && this.listData.question.fillInTheRange.textCorrect) {
              this.fillInTheRange = this.listData.question ? this.listData.question.fillInTheRange: null;
            }

            if(this.listData && this.listData.question && this.listData.question.essay && this.listData.question.essay.textAnswer) {
              this.essay = this.listData.question ? this.listData.question.essay: null;
            }

            //console.log('EaxmIssueresponseData=>',this.fillInTheRange)
          }).catch((err) => {
              console.log('error=>',err)
          });
    }
  },
};
</script>

<style scoped>
.font-13 {
            font-size: 13px !important;
        }

        .l-spacing39 {
            letter-spacing: -0.39px;
        }
        .leftborder:before{
            content: '';
            position: absolute;
            width: 3px;
            height: 100%;
            border-radius: 4px;
            background: var(--ContentBlue);
            top:0;
            left: -3px;
        }
        html[dir="rtl"] .leftborder:before{
            right: -3px;
        }
        .problem {
            background-color: var(--QuizGray);
        }

        .problem .problem-sl-no {
            border: 1px solid var(--Textfeildactive);
            border-radius: 50%;
        }

        .problem.selected {
            background-color: var(--ContentBlue);
        }
        .problem.selected .problem-sl-no{
            color: var(--ContntentBlue) !important;
            border: 2px solid var(--DocumentWhite);
        }
        .problem.selected .answer{
            color: var(--DocumentWhite) !important;
        }
        .t-color-blue{
            color: var(--Primary) !important
        }
</style>
